// extracted by mini-css-extract-plugin
export default {"container":"SaveBanner_container__DCZx+","spacer":"SaveBanner_spacer__AFbuO"};